import { Button } from '@/components/ui/button';
import { Modal } from './Modal';

interface Props {
  open: boolean;
  existingFileCount: number;
  onCancel: () => void;
  onConfirm: () => void;
  busy?: boolean;
}

/**
 * 파일 저장소 백엔드를 변경할 때 띄우는 확인 모달.
 * existingFileCount > 0 일 때만 호출하는 것이 호출자 책임.
 */
export function ConfirmStorageChangeModal({
  open,
  existingFileCount,
  onCancel,
  onConfirm,
  busy,
}: Props) {
  return (
    <Modal
      open={open}
      onClose={onCancel}
      title="기존 파일에 접근할 수 없게 됩니다"
      size="md"
      footer={
        <div className="flex items-center justify-end gap-2">
          <Button type="button" variant="secondary" onClick={onCancel} disabled={busy}>
            취소
          </Button>
          <Button type="button" variant="danger" onClick={onConfirm} disabled={busy}>
            {busy ? '변경 중…' : '변경하기'}
          </Button>
        </div>
      }
    >
      <p className="text-sm leading-relaxed">기존 파일에 접근할 수 없게 됩니다.</p>
      <p className="mt-2 text-sm leading-relaxed">신규 파일만 정상 작동합니다.</p>
      <p className="mt-3 text-sm leading-relaxed font-medium">정말 변경하시겠습니까?</p>
      <p className="mt-4 text-xs text-foreground-muted">
        현재 등록된 파일 {existingFileCount.toLocaleString('ko-KR')}개는 새 백엔드에서 자동으로
        마이그레이션되지 않습니다.
      </p>
    </Modal>
  );
}
